import React, { Component, Fragment } from "react";
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Row from '../row';
import Col from '../col';
import Form from '../form';
import Input from '../input';
import Select from '../select';
import DatePicker from '../date-picker';
import InputNumber from '../input-number';
import TreeSelect from '../tree-select';
import Cascader from '../cascader';
import Button from '../button';
import Upload from '../upload';
import Icon from '../icon';
import Radio from '../radio';
import Checkbox from '../checkbox';
import TimePicker from '../time-picker';
import AutoComplete from '../auto-complete';
import Slider from '../slider';
import Divider from '../divider';
import Rate from '../rate';
import PopEdit from '../pop-edit';
import LocaleReceiver from 'antd/es/locale-provider/LocaleReceiver';
import defaultLocale from '../locale/default';
import "@whalecloud/fdx-theme-fdx/dynamic-attribute.less";


interface DynamicAttrLocale {
    upload: string,
    clickToUpload: string
}


const judgeShowTime = (values, id) => {
  const targetItem = values.find(v => v.attrId === id) || {};
  if (Object.keys(targetItem).length) {
    const { attrValue } = targetItem;
    return attrValue.indexOf(' ') > -1 && attrValue.split(' ').length === 2;
  }
  return false;
};

const transFishformToFdx = (format, values, id) => {
  const showTime = judgeShowTime(values, id);
  let fdxFormat = format.toUpperCase();
  fdxFormat = fdxFormat.replace('II', 'mm');
  fdxFormat = fdxFormat.replace(':MM', ':mm'); // #98
  fdxFormat = fdxFormat.replace('SS', 'ss');
  if (fdxFormat.split(' ').length > 1) return fdxFormat;
  return showTime ? `${fdxFormat} HH:mm:ss` : fdxFormat;
};
const FormItem = Form.Item;
const { Option } = Select;
const { TextArea } = Input;
const COMMONRule = {
  required: true,
  msg: 'Required',
};
const COMMONDATE_RULE = {
  type: 'object',
  required: true,
  msg: 'Required'
};
const COMMONARRAY_RULE = {
  type: 'array',
  required: true,
  msg: 'Required',
};
// 默认表单一行一组控件
const ColLayout = {
  xs: 24,
  sm: 24,
  md: 24,
  xl: 24,
};

// 默认label和输入控件的样式布局
const FormItemLayout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 17,
  },
};

interface ILayoutProps {
  id?: string;
  label?: string;
  type?: string;
  data?: object[];
  bindctrl?: string;
  rules?: object[];
  ctrlProps?: object;
  format?: string;
  addRegistry?: object
}

interface IFormProps {
  hideRequiredMark?: boolean;
  labelAlign?: ['left' | 'right'];
  layout?: ['horizontal' | 'vertical' | 'inline'];
  formItemLayout?: object;
  colLayout?: object;
  onSubmit?: ((form: any) => void);
}

interface IInitValuesProps {
  attrId?: string;
  attrValue?: string;
}
interface RegProps {
  type: string;
  getComp: () => {}
}
interface DAProps {
  form?: any;
  layout?: ILayoutProps[];
  initValues?: IInitValuesProps[];
  formProps?: IFormProps;
  onChange?: ((id: string, value: string) => void);
  additionRegistry: RegProps[];
}

interface DAState {
  emailSearchResult: string[];
  popEditModalVisible: boolean;
  registry: object
}

interface IRestProps {
  disabled?: boolean;
}

class DynamicAttribute extends Component<DAProps, DAState> {
  constructor(props) {
    super(props);
    this.state = {
      emailSearchResult: [],
      popEditModalVisible: false,
      registry: {
        text: this.renderInput,
        textarea: this.renderInput,
        password: this.renderInput,
        hidden: this.renderInput,
        datetimepicker: this.renderDatePicker,
        dateRangePicker: this.renderDatePicker,
        combobox: this.renderSelect,
        multiselect: this.renderSelect,
        number: this.renderNumber,
        popedit: this.renderPopEdit,
        treeSelect: this.renderTreeSelect,
        cascader: this.renderCascader,
        file: this.renderFile,
        radioGroup: this.renderRadioGroup,
        radioButton: this.renderRadioGroup,
        checkbox: this.renderCheckbox,
        timePicker: this.renderTimePicker,
        combination: this.renderCombination,
        email: this.renderEmail,
        slider: this.renderSlider,
        rate: this.renderRate,
        submit: this.renderSubmit,
        ...this.appendAddition()
      }
    }
  }

  static propTypes = {
    formProps: PropTypes.object,
    layout: PropTypes.array,
    initValues: PropTypes.array,
  };

  static defaultProps = {
    formProps: {
      colLayout: ColLayout,
      formItemLayout: FormItemLayout,
    },
    layout: [],
    initValues: [],
    additionRegistry: [],
  };

  appendAddition = () => {
    const { additionRegistry } = this.props;
    const registries = {};
    if (!additionRegistry.length) {
      return registries;
    }

    additionRegistry.forEach((reg) => {
      registries[reg.type] = this.renderOther
    })

    return registries;
  }
  // 暴露给外部的方法
  getFieldsValue = e => {
    if (e) {
      e.preventDefault();
    }
    const { form, layout, initValues, formProps } = this.props;
    const { onSubmit } = formProps;
    if (onSubmit) {
      onSubmit(form);
      return;
    }
    const values = {};
    let valid = true;
    form.validateFields((err, fieldsValue) => {
      if (err) {
        valid = false;
        return;
      }
      Object.keys(fieldsValue).forEach(key => {
        const value = fieldsValue[key];
        if (moment.isMoment(value)) {
          const targetItem = layout.find(v => v.id === key);
          const { id, format = 'YYYY-MM-DD' } = targetItem;
          const realFormat = transFishformToFdx(format, initValues, id);
          values[key] = value.format(realFormat);
        } else values[key] = value;
      });
    });
    return valid ? values : false;
  }

  resetFields = () => {
    const { form: { resetFields } } = this.props;
    resetFields();
  }

  judgeIfContain = (item, currentValue, type) => {
    let containFlag = true;
    if (type === 'multiselect' && !Array.isArray(currentValue)) currentValue = currentValue.split("|");
    const { form: { getFieldValue } } = this.props;
    const { bindctrl, data = [] } = item;
    const ctrlVal = getFieldValue(bindctrl);
    const options = data.filter(v => v.bindTo === ctrlVal);
    if (Array.isArray(currentValue)) {
      const optionValues = options.map(v => v.value);
      if (currentValue.some(v => !optionValues.includes(v))) {
        containFlag = false;
      }
    } else if (!options.some(v => v.value === currentValue)) {
      containFlag = false;
    }
    return containFlag;
  }

  handleMultiValues = (type, value) => {
    if (type === 'multiselect') {
      if (!value) return [];
      return value.split("|");
    }
    if (type === 'datetimepicker') {
      return value ? moment(value) : null;
    }
    return value;
  }

  handleInit = item => {
    const { initValues } = this.props;
    const { id, type, bindctrl } = item;
    if (initValues.length > 0) {
      const targetItem = initValues.find(v => v.attrId === id) || {};
      if (Object.keys(targetItem).length) {
        if (bindctrl) {
          if (targetItem.attrValue) {
            if (!this.judgeIfContain(item, targetItem.attrValue, type)) {
              return type === 'multiselect' ? [] : null
            }
          }
        }
        return this.handleMultiValues(type, targetItem.attrValue)
      }
      return type === 'multiselect' ? [] : null;
    }
    return type === 'multiselect' ? [] : null;
  }

  generateSelectBefore = (data, restProps, id) => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { initValues } = this.props;
    const targetItem = initValues.find(v => v.attrId === id) || {};
    return getFieldDecorator('prefixProtocol', {
      initialValue: targetItem.attrValue,
    })(
      <Select className="dynamic-select" style={{ width: 90 }} {...restProps}>
        {data.length !== 0 && data.map((item, index) => <Option value={item} key={`protocol-${index}`}>{item}</Option>)}
      </Select>
    );
  }

  generateSelectAfter = (data, restProps, id) => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { initValues } = this.props;
    const targetItem = initValues.find(v => v.attrId === id) || {};
    return getFieldDecorator('suffixSite', {
      initialValue: targetItem.attrValue,
    })(
      <Select className="dynamic-select" style={{ width: 80 }} {...restProps}>
        {data.length !== 0 && data.map((item, index) => <Option value={item} key={`site-${index}`}>{item}</Option>)}
      </Select>
    );
  }

  renderOptions = item => {
    const { bindctrl, data, id, type } = item;
    const { form: { getFieldValue, resetFields } } = this.props;
    let options = data;
    if (bindctrl) {
      const ctrlVal = getFieldValue(bindctrl);
      if (ctrlVal) {
        options = data.filter(v => v.bindTo === ctrlVal);
      }
      // 若当前选择项不全部属于bindctrl，需要清空选择项
      const currentValue = getFieldValue(id);
      if (currentValue) {
        if (!this.judgeIfContain(item, currentValue, type)) {
          resetFields([id]);
        }
      }
    }
    return options.map(iem => (
      <Option value={iem.value} key={`${bindctrl}_${iem.value}_${iem.name}`}>
        {iem.name}
      </Option>
    ))
  }

  renderItem = (item, index) => {
    const { formProps } = this.props;
    const { registry } = this.state;
    const { colLayout = ColLayout, formItemLayout = FormItemLayout } = formProps;
    const { type, label, colLayout: itemColLayout = colLayout, formItemLayout: itemFormLayout = formItemLayout, ctrlProps = {} } = item;
    const { readOnly = false } = ctrlProps;
    let renderFunc = registry[type];
    let relColLayout = { ...itemColLayout };
    if (item.type === 'hidden') relColLayout = { span: 0 }; // #98 隐藏 FormItem 同时 需要隐藏包裹 FormItem 的 Col
    return (
      <Col key={`dynamic_${index}`} {...relColLayout}>
        {type === 'divider' ? <Divider /> :
          <FormItem className={classNames('dynamic-form-item', { 'readOnlyItem': readOnly === true, 'hiddenItem': type === 'hidden' })} {...itemFormLayout} label={label}>{renderFunc(item, index)}</FormItem>}
      </Col>
    )
  }

  renderCommonAttrs = item => {
    const { onChange } = this.props;
    const { ctrlProps = {} } = item;
    const params = { ...ctrlProps };
    if (onChange) {
      params.onChange = (value) => { 
        onChange(item.id, value) 
      }
    }
    return params;
  }

  renderSubmit = item => {
    const { ctrlProps = {}, btnProps = {}, } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const { label = 'submit' } = btnProps;

    return <Fragment>
      <Button type="primary" htmlType="submit" {...restProps}>{label}</Button>
    </Fragment>;
  }

  filterRules = (rules = []) => {
    rules.forEach(rule => {
      if (rule.pattern !== undefined) {
        const flag = rule.flag || 'i';
        rule.pattern = new RegExp(rule.pattern, flag);
      }
    });
    return rules;
  }

  renderInput = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { datarule = '', id, required, type, rules = [] } = item;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONRule);
    const key = "length";
    if (datarule.length > 0 && datarule.indexOf(key) > -1) {
      const index = datarule.indexOf(key) + key.length;
      const maxmin = datarule.substring(index, datarule.length);
      const min = maxmin.substring(1, maxmin.indexOf("~"));
      const max = maxmin.substring(maxmin.indexOf("~") + 1, maxmin.length - 1);
      if (min !== '') rulesDefault.unshift({
        min: parseInt(min, 10)
      });
      if (max !== '') rulesDefault.unshift({
        max: parseInt(max, 10)
      });
    }
    if (type === 'textarea') {
      return getFieldDecorator(id, {
        initialValue: this.handleInit(item),
        rules: rulesDefault,
      })(
        <TextArea {...this.renderCommonAttrs(item)} />
      );
    }
    if (type === 'text') {
      return getFieldDecorator(id, {
        initialValue: this.handleInit(item),
        rules: rulesDefault,
      })(
        <Input {...this.renderCommonAttrs(item)} />
      );
    }
    if (type === 'password') {
      return getFieldDecorator(id, {
        initialValue: this.handleInit(item),
        rules: rulesDefault,
      })(
        <Input.Password {...this.renderCommonAttrs(item)} />
      );
    } else {
      return getFieldDecorator(id, {
        initialValue: this.handleInit(item),
      })(
        <Input />
      );
    }
  }
  renderOther = item => {
    const {
      form: { getFieldDecorator },
      additionRegistry
    } = this.props;
    const { required, id, rules = [] } = item;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const reg = additionRegistry.find(function (data) { return data.type === id });
    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      reg.getComp()
    );
  }

  renderNumber = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [] } = item;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      <InputNumber
        className="dynamic-input-number"
        {...this.renderCommonAttrs(item)}
      />
    );
  }

  getUploadBtn = (item, restProps, locale) => {
    const { ctrlProps = {} } = item;
    const { listType } = ctrlProps;
    if (listType === 'picture-card') {
      return(
        <div>
          <Icon type="plus" />
          <div className="ant-upload-text">{locale.upload}</div>
        </div>
      )
    }
    return (
      <Button {...restProps}>
        <Icon type="upload" /> {locale.clickToUpload}
      </Button>
    )
  }
  
  renderFile = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {} } = item;
    const { readOnly = false} = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const fileProps = {
      ...this.renderCommonAttrs(item),
      ...restProps
    }

    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      <Upload {...fileProps}>
        <LocaleReceiver componentName="DynamicAttribute" defaultLocale={defaultLocale.DynamicAttribute}> 
        {(locale: DynamicAttrLocale) => this.getUploadBtn(item, restProps, locale)}
        </LocaleReceiver>
      </Upload>
    );
  }

  renderSlider = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {}, data = {} } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const sliderProps = {
      ...this.renderCommonAttrs(item),
      ...restProps,
      marks: data
    }

    return getFieldDecorator(id, {
      initialValue: this.handleInit(item) || 0,
      rules: rulesDefault,
    })(
      <Slider {...sliderProps} />
    );
  }

  renderRate = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {}, data = {} } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const sliderProps = {
      ...this.renderCommonAttrs(item),
      ...restProps,
      marks: data
    }

    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      <Rate className="dynamic-rate" {...sliderProps} />
    );
  }

  renderCombination = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, prefixId, suffixId, rules = [], ctrlProps = {}, addonBefore = ['Http://', 'Https://'], addonAfter = ['.com', '.jp', '.cn', '.org'] } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const urlProps = {
      ...this.renderCommonAttrs(item),
      ...restProps,
      allowClear: true,
      addonBefore: this.generateSelectBefore(addonBefore, restProps, prefixId),
      addonAfter: this.generateSelectAfter(addonAfter, restProps, suffixId),
    }

    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      <Input {...urlProps} />
    );
  }

  filterEmail = (value, data = []) => {
    let emailSearchResult;
    if (!value || value.indexOf('@') >= 0) {
      emailSearchResult = [];
    } else {
      emailSearchResult = data.map(domain => `${value}@${domain}`);
    }
    this.setState({
      emailSearchResult
    });
  }

  renderEmailOption = item => {
    const { data = [], id } = item;
    const { form: { getFieldValue } } = this.props;
    const target = getFieldValue(id);
    return this.filterEmail(target, data);
  }

  renderEmail = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {} } = item;
    const { readOnly = false } = ctrlProps;
    const { emailSearchResult = [] } = this.state;
    const children = emailSearchResult.map(email => <AutoComplete.Option key={email}>{email}</AutoComplete.Option>);
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const emailProps = {
      ...this.renderCommonAttrs(item),
      ...restProps,
      allowClear: true,
      style: { width: '100%' },
      onSearch: () => this.renderEmailOption(item)
    }
    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      <AutoComplete {...emailProps}>
        {children}
      </AutoComplete>
    );
  }

  renderRadioGroup = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {}, data = [], type } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const radioProps = {
      ...this.renderCommonAttrs(item),
      ...restProps
    }

    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(this.renderGroup(type, data, radioProps));
  }

  renderGroup = (type, data = [], props) => {
    if (type === 'radioGroup') {
      return <Radio.Group className="dynamic-radio-group" {...props}>
        {data.length !== 0 && data.map((radio, index) => <Radio value={radio.value} key={`radio-group-${index}`}>{radio.label}</Radio>)}
      </Radio.Group>
    } else {
      return <Radio.Group className="dynamic-radio-group" {...props}>
        {data.length !== 0 && data.map((radio, index) => <Radio.Button value={radio.value} key={`radio-button-${index}`}>{radio.label}</Radio.Button >)}
      </Radio.Group>
    }
  }

  renderCheckbox = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {}, data = [] } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const checkboxProps = {
      options: data,
      ...this.renderCommonAttrs(item),
      ...restProps
    }

    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault,
    })(
      <Checkbox.Group className="dynamic-checkbox-group" {...checkboxProps} />
    );
  }

  renderDateItem = (props, type) => {
    switch (type) {
      case 'datetimepicker':
        return <DatePicker {...props} />;
      case 'dateRangePicker':
        return <DatePicker.RangePicker className="dynamic-range-picker" {...props} />
      default:
        break;
    }
  }

  renderDatePicker = item => {
    const {
      form: { getFieldDecorator },
      initValues,
    } = this.props;
    const { required, id, format, type, ctrlProps = {}, rules = [] } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    let fdxFormat = format;
    if (format){
        fdxFormat = transFishformToFdx(format, initValues, id);
    }
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const dateProps = {
      style: { width: '100%' },
      format: fdxFormat,
      allowClear: true,
      showTime: judgeShowTime(initValues, id),
      ...this.renderCommonAttrs(item),
      ...restProps
    }
    const initTime = type !== 'dateRangePicker' ? this.handleInit(item) : this.formatRangeTime(this.handleInit(item), fdxFormat);

    return getFieldDecorator(id, {
      initialValue: initTime,
      rules: rulesDefault,
    })(this.renderDateItem(dateProps, type));
  }

  formatRangeTime = (value, format) => {
    if (value === null) return null;
    return value.map(time => moment(time, format));
  }

  renderTimePicker = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, format = 'HH:mm:ss', ctrlProps = {}, rules = [] } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const timeProps = {
      style: { width: '100%' },
      format,
      allowClear: true,
      ...this.renderCommonAttrs(item),
      ...restProps
    }
    const initTime = this.handleInit(item) ? moment(this.handleInit(item), format) : null;
    return getFieldDecorator(id, {
      initialValue: initTime,
      rules: rulesDefault,
    })(
      <TimePicker {...timeProps} />
    );
  }

  renderSelect = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, type, rules = [], ctrlProps = {} } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(type === "multiselect" ? COMMONARRAY_RULE : COMMONRule);
    const selectProps = {
      allowClear: true,
      width: '100%',
      ...this.renderCommonAttrs(item),
      ...restProps
    }
    if (type === "multiselect") selectProps.mode = "multiple";
    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault
    })(
      <Select className="dynamic-select" {...selectProps}>
        {this.renderOptions(item)}
      </Select>
    );
  }

  renderTreeSelect = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {} } = item;
    const { readOnly = false } = ctrlProps;

    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const selectTreeProps = {
      width: '100%',
      allowClear: true,
      dropdownStyle: { maxHeight: 400, overflow: 'auto' },
      treeDefaultExpandAll: true,
      ...this.renderCommonAttrs(item),
      ...restProps
    }
    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault
    })(
      <TreeSelect className="dynamic-select" {...selectTreeProps} />
    );
  }

  renderCascader = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, rules = [], ctrlProps = {} } = item;
    const { readOnly = false } = ctrlProps;
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    const cascaderProps = {
      width: '100%',
      allowClear: true,
      ...this.renderCommonAttrs(item),
      ...restProps
    }
    return getFieldDecorator(id, {
      initialValue: this.handleInit(item),
      rules: rulesDefault
    })(
      <Cascader className="dynamic-cascader" {...cascaderProps} />
    );
  }

  renderPopEdit = item => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { required, id, popeditProps = {}, rules = [], ctrlProps = {} } = item;
    const { readOnly = false,  } = ctrlProps;
    const rulesDefault = this.filterRules(rules);
    if (required) rulesDefault.unshift(COMMONDATE_RULE);
    let restProps: IRestProps = {};
    if (readOnly) restProps.disabled = true;
    popeditProps.inputProps = {
      width: '100%',
      ...ctrlProps,
      ...popeditProps.inputProps,

    }
    popeditProps.modalProps = {
      ...this.renderCommonAttrs(item),
      ...popeditProps.modalProps
    }
    const defaultProps = {
      ...restProps,
      ...popeditProps
    }
    let defaultValue = this.handleInit(item);
    if (typeof defaultValue === 'string') {
      try {
        defaultValue = JSON.parse(defaultValue)
      } catch (error) {
        // console.log('popEdit 数据格式错误：', error)
      }
    }
    return getFieldDecorator(id, {
      initialValue: defaultValue,
      rules: rulesDefault
    })(
      <PopEdit {...defaultProps}/>
    );
  }

  handleProps = (formProps) => {
    // eslint-disable-next-line no-unused-vars
    const { colLayout = ColLayout, formItemLayout = FormItemLayout, ...resetProps } = formProps;
    return {
      ...colLayout,
      ...formItemLayout,
      ...resetProps
    }
  }

  render() {
    const { layout, formProps, children } = this.props;
    return (
      <div className="fdx-form">
        <Form {...this.handleProps(formProps)} onSubmit={this.getFieldsValue}>
          <Row>
            {layout.map(this.renderItem)}
            {children}
          </Row>
        </Form>
      </div>
    )
  }
}

export default Form.create()(DynamicAttribute);



// WEBPACK FOOTER //
// ./src/components/dynamic-attribute/index.tsx